import type UserModel from '../models/user';
import request from './request';

export type LoginCredentials = Pick<UserModel, 'email' | 'password'>;

export interface LoginResponse {
  status?: string;
  message?: string;
  error?: string;
  user?: Partial<UserModel>;
  token?: string;
}

const authService = {
  login: async (data: LoginCredentials): Promise<LoginResponse> => {
    const response = await request.post<LoginResponse>('/login', data, {
      skipAuth: true,
    });
    return response.data;
  },
};

export default authService;